// Routes
export const HOME_TEST = '/tests';
export const HOME_FORM_TEST = `${HOME_TEST}/form`;
export const HOME_PAGE_ROUTE = '/home';
export const ERROR_LOGIN_PAGE_ROUTE = '/error';
export const HOME_FORM_ROUTE = `${HOME_PAGE_ROUTE}/form`;
export const CONNECTION_INFO_FORM = `${HOME_PAGE_ROUTE}/connection`;
export const PERSONAL_INFO_FORM = `${HOME_PAGE_ROUTE}/personal`;
export const EMERGENCY_INFO_FORM = `${HOME_PAGE_ROUTE}/emergency`;
export const PAIR_DEVICE_ONE = `${HOME_PAGE_ROUTE}/associatedevice/1`;
export const PAIR_DEVICE_TWO = `${HOME_PAGE_ROUTE}/associatedevice/2`;
export const PROFESSIONAL_INFO_FORM = `${HOME_PAGE_ROUTE}/professional`;
export const STRUCTURE_INFO_FORM = `${HOME_PAGE_ROUTE}/structure`;
export const COLLAB_INFO_DRAWER = `${HOME_PAGE_ROUTE}/collaborators-info`;

export const CONTACT_PAGE = '/contact';
export const ACTIVATION = '/activate-account';

export const CREATION = '/create-account';
export const RATTACHEMENT_DEMANDE = '/rattachement-demande';
export const ENROLEMENT = '/enrolement/:entiteId/:idnInvitor/:token';
export const COLLABORATORS_MANAGEMENT = '/collaborators-management/:entiteId';
export const COLLABORATORS_MANAGEMENT_COLLAB_INFO_DRAWER = `${COLLABORATORS_MANAGEMENT}/collaborators-info`;

export const CHARTE_ETHIQUE = '/doc/charte-ethique';
export const CGU = '/doc/mentions-legales';
export const FAQ = '/doc/faq';

export const MON_ID_NUM = '/mon-identite-numerique';

export const GP_ACTIVATION = '/activation/gp/:key';

export const PRO_ACTIVATION = '/activation/pro/:key';

export const VERIFICATION_MAIL = '/authentification/verificationmail';

export const ACCOUNT_ALREADY_ACTIVATED = '/activation/accountalreadyactivated';

export const VERIFICATION_NVX_EMAIL = '/authentification/verificationmail/:key';
